import { createContext } from "react";

export type InternetStatusContextType = {
  online: boolean;
  downlink: number | null;
  downlinkMax: number | null;
  effectiveType: "slow-2g" | "2g" | "3g" | "4g" | null;
  rtt: number | null;
  saveData: boolean | null;
  type: string | null;
  isOnline: boolean;
  connectionStatus: "online" | "offline";
};

export const InternetStatusContext = createContext<InternetStatusContextType | null>(null);
